import franceContactsConfig from "./contacts.config";

// France has a single office currently; extendable for future branches
const officesConfig = [franceContactsConfig];

export default officesConfig;
